import { MdsvexOptions } from './types';

export const defineConfig = (config: MdsvexOptions) => config;
